<template>
    <div
        :style="styles"
        class="o-services-buttons services-buttons"
    >
        <AServiceButton
            v-for="(item, index) in preparedServices"
            :key="index"
            :item="item"
            @click="showModal"
        />
        <AServicesButton
            v-if="isServicesButton"
            :view="view"
            class="services-buttons-show-all"
        />
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import AServiceButton from '../../atoms/a-service-button/a-service-button';
import AServicesButton from "../../atoms/a-services-button/a-services-button";

import {
    EVENTS,
    SHOW_MODAL
}
    from '../../../utils/constants/bus-events-constants';
import { TERMINAL_VIDEOSHOP } from "../../../utils/constants/pages";

export default {
    name: "OServicesButtons",
    components: {
        AServicesButton,
        AServiceButton
    },
    props: {
        view: {
            type: String,
            default: ''
        },
        isDesktop: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters([
            't',
            'getMapConfigProp',
            'getObjectsByCategory',
            'getServicesCategoriesRootLevel'
        ]),
        isServicesButton() {
            return this.getServicesCategoriesRootLevel.length > Number(this.params.quantityServices)
                && (this.params.isViewAllButton ?? true);
        },
        preparedServices() {
            return this.getServicesCategoriesRootLevel.slice(0, this.params.quantityServices || 9);
        },
        commonConfigParams() {
            return this.getMapConfigProp('components.OServicesButtons.params') || {};
        },
        viewConfigParams() {
            return this.getMapConfigProp(`views.${this.view}.footer.OServicesButtons.params`) || {};
        },
        params() {
            return {
                ...this.commonConfigParams,
                ...this.viewConfigParams
            }
        },
        commonConfigStyles() {
            return this.getMapConfigProp('components.OServicesButtons.styles') || {};
        },
        viewConfigStyles() {
            return this.getMapConfigProp(`views.${this.view}.footer.OServicesButtons.styles`) || {};
        },
        styles() {
            return {
                ...this.commonConfigStyles,
                ...this.viewConfigStyles
            }
        },
        isKinoIntegrationActive(){
            return this.getMapConfigProp('features.integrations.odeon_kino', false);
        },
    },
    methods: {
        showModal(data) {
            if ( this.isKinoIntegrationActive && data.meta.is_kino) {
                const cinemaId = this.t(this.getObjectsByCategory(data.id)[0], 'cinemaId');

                this.$store.commit('setCinemaId',cinemaId);
                this.$router.push({ name: TERMINAL_VIDEOSHOP, query: { cinemaId } });
            } else if(this.isDesktop) {
                const params = {
                    component: 'services',
                    data: {
                        ...data
                    }
                };
                this.$bus.$emit(SHOW_MODAL, params);
            } else if (data.meta.is_transport) {
                this.$router.push({ name: 'terminal.transport' });
            } else {
                const params = {
                    itemId: data.id,
                    label: false
                };
                this.$bus.$emit(EVENTS.MODALS.INIT_SERVICES_MODAL, params, this.view);
            }
        }
    }
}
</script>

<style lang="scss" src="./o-services-buttons.scss" />
